import { jsx } from "react/jsx-runtime";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import { validateTidalLicense } from "../../base/index.js";
function ArrowDropDownCircleOutlined(props) {
  return /* @__PURE__ */ jsx(
    ArrowDropDownCircleOutlinedIcon,
    {
      "data-testid": "ArrowDropDownCircleOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ArrowDropDownCircleOutlined",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ArrowDropDownCircleOutlined.tidalIconMeta = {
  categories: "arrows",
  name: "ArrowDropDownCircleOutlined"
};
validateTidalLicense();
export {
  ArrowDropDownCircleOutlined
};
//# sourceMappingURL=ArrowDropDownCircleOutlined.js.map
